import { css } from '@emotion/css';
import React from 'react';

interface HeaderButtonProps {
  ariaLabel: string;
  background?: string;
  onClick?: () => void;
}

export const HeaderButton: React.FC<HeaderButtonProps> = ({
  ariaLabel,
  background,
  onClick,
  children
}) => {
  return (
    <button
      className={css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 48px;
        height: 48px;
        transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49);
        padding: 0;
        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 32px;
          height: 32px;
          background: ${background || '#f5f1e3'};
          border-radius: 50%;
        }
        :active {
          transform: scale(0.85);
        }
      `}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <span className="icon">{children}</span>
    </button>
  );
};
